import React from 'react';
import { cn } from '../../utils/cn';
interface CardProps extends React.HTMLAttributes<HTMLDivElement> {
  hoverable?: boolean;
}
export function Card({
  className,
  hoverable = false,
  children,
  ...props
}: CardProps) {
  return <div className={cn('bg-brand-gray-900 border border-brand-gray-800 p-8 relative group', hoverable && 'hover:border-brand-teal transition-colors duration-300 cursor-pointer', className)} {...props} data-id="element-78">
      {/* Tactical corner accents */}
      <div className="absolute top-0 left-0 w-2 h-2 border-t-2 border-l-2 border-brand-teal opacity-0 group-hover:opacity-100 transition-opacity" data-id="element-79" />
      <div className="absolute top-0 right-0 w-2 h-2 border-t-2 border-r-2 border-brand-teal opacity-0 group-hover:opacity-100 transition-opacity" data-id="element-80" />
      <div className="absolute bottom-0 left-0 w-2 h-2 border-b-2 border-l-2 border-brand-teal opacity-0 group-hover:opacity-100 transition-opacity" data-id="element-81" />
      <div className="absolute bottom-0 right-0 w-2 h-2 border-b-2 border-r-2 border-brand-teal opacity-0 group-hover:opacity-100 transition-opacity" data-id="element-82" />

      {children}
    </div>;
}